import { Button } from '../../button';
import React from 'react';
import styled from 'styled-components';

export const ListHeader = (props) => (
  <Wrapper>
    <div>
      {`${props.count || 0} Selected`}
    </div>
    <div className="flex items-center">
      {props.onSave &&
        <div className="mr-2">
          <Button onClick={props.onSave} type='solid' title="Save" />
        </div>
      }
      <Button
        onClick={props.count && props.count > 0 ? props.onClear : props.onSelectAll}
        type='text'
        title={props.count && props.count > 0 ? 'Clear' : 'Select All'}
      />
    </div>
  </Wrapper>
)

const Wrapper = styled.div`
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding-left: 12px;
  padding-right: 12px;

  border: 1px solid #E3E3E3;
  border-radius: 8px 8px 0px 0px;

  border-bottom-width: 0px;
`;